import apiConfig from './config';

const getNotificaciones = (queryString, success, error) => {
	const token = localStorage.getItem(apiConfig.constants.ACCESS_TOKEN_KEY) || null;

	return fetch(`${apiConfig.constants.URL_API}/api/${apiConfig.constants.API_VERSION}/notificaciones${ queryString }`, {
		headers: {
			Authorization: `Bearer ${ token }`,
			Accept: 'application/json'
		}
	})
	.then(apiConfig.methods.checkStatus)
	.then(apiConfig.methods.parseJSON)
	.then(success)
	.catch(apiConfig.methods.error)
	.then(error);
};

const getNotificacion = (id, success, error) => {
	const token = localStorage.getItem(apiConfig.constants.ACCESS_TOKEN_KEY) || null;

	return fetch(`${apiConfig.constants.URL_API}/api/${apiConfig.constants.API_VERSION}/notificaciones/${ id }`, {
		headers: {
			Authorization: `Bearer ${ token }`,
			Accept: 'application/json'
		}
	})
		.then(apiConfig.methods.checkStatus)
		.then(apiConfig.methods.parseJSON)
		.then(success)
		.catch(apiConfig.methods.error)
		.then(error);
};

const createNotificacion = (data, success, error) => {
	const token = localStorage.getItem(apiConfig.constants.ACCESS_TOKEN_KEY) || null;

	return fetch(`${apiConfig.constants.URL_API}/api/${apiConfig.constants.API_VERSION}/notificaciones`, {
		method: 'post',
		body: JSON.stringify(data),
		headers: {
			Authorization: `Bearer ${ token }`,
			'Accept': 'application/json',
			'Content-Type': 'application/json',
		},
	})
		.then(apiConfig.methods.checkStatus)
		.then(apiConfig.methods.parseJSON)
		.then(success)
		.catch(apiConfig.methods.error)
		.then(error);
};

const updateNotificacion = (data, success, error) => {
	const token = localStorage.getItem(apiConfig.constants.ACCESS_TOKEN_KEY) || null;
	
	return fetch(`${apiConfig.constants.URL_API}/api/${apiConfig.constants.API_VERSION}/notificaciones/${ data.id }`, {
		method: 'put',
		body: JSON.stringify(data),
		headers: {
			Authorization: `Bearer ${ token }`,
			'Accept': 'application/json',
			'Content-Type': 'application/json',
		},
	})
		.then(apiConfig.methods.checkStatus)
		.then(apiConfig.methods.parseJSON)
		.then(success)
		.catch(apiConfig.methods.error)
		.then(error);
};

const deleteNotificacion = (id, success, error) => {
	const token = localStorage.getItem(apiConfig.constants.ACCESS_TOKEN_KEY) || null;
	
	return fetch(`${apiConfig.constants.URL_API}/api/${apiConfig.constants.API_VERSION}/notificaciones/${ id }`, {
		method: 'delete',
		headers: {
			Authorization: `Bearer ${ token }`,
			'Accept': 'application/json',
			'Content-Type': 'application/json',
		},
	})
		.then(apiConfig.methods.checkStatus)
		.then(apiConfig.methods.parseJSON)
		.then(success)
		.catch(apiConfig.methods.error)
		.then(error);
};

const exportedObject = {
	getNotificaciones,
	getNotificacion,
	createNotificacion,
	updateNotificacion,
	deleteNotificacion
}

export default exportedObject;